import { useQuery } from 'react-query';
import {getSummary} from "../api";
import useCurrentUser from "./useCurrentUser";

const useSummary = () => {
  const { token, userID } = useCurrentUser();
  //const urlParams = new URLSearchParams(window.location.search);
  //const quoteId = urlParams.keys().next().value;
  const result = useQuery('summary_', () => getSummary(token, userID, null), {
    refetchOnWindowFocus: false,
    staleTime: 5000,
  });
  return result;
};

export default useSummary;
